{
  "version": 1,
  "source": "docs/reference/painting-1538-amsterdam-museum.jpg",
  "sourceSize": [6692, 4866],
  "notes": "Eight approximate picks of visible tile-roof masses in the island across the canal from the Nieuwe Kerk. Sequence and tile appearance are source readings; correspondence to the retained Molsteeg\u2013Mosterdpotsteeg area is provisional. Fourteen opposite properties, their roof materials, all storeys, metric frontages, depths and axes are estimates. Broad painted masses are represented by explicitly inferred narrower properties; these are not thirty individually identified historical houses. No anonymous inner filler. See docs/mol-mosterd-comparison.md.",
  "rows": [
    {
      "id": "mol-mosterd-voorburgwal",
      "source": "quay-nieuwezijds-voorburgwal-4",
      "side": "right",
      "from": 539,
      "to": 460,
      "depth": 15,
      "shear": 0.04,
      "opposite": "quay-nieuwezijds-achterburgwal",
      "evidence": "painted",
      "houses": [
        {
          "id": "mol-mosterd-voorburgwal-01",
          "widthWeight": 1.15,
          "storeys": 3,
          "roof": "tile",
          "gable": "plain",
          "plots": [
            {
              "id": "mol-mosterd-voorburgwal-01/a",
              "widthWeight": 1
            },
            {
              "id": "mol-mosterd-voorburgwal-01/b",
              "widthWeight": 1
            }
          ],
          "paintedPixel": [4180, 1932]
        },
        {
          "id": "mol-mosterd-voorburgwal-02",
          "widthWeight": 0.85,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "plots": [
            {
              "id": "mol-mosterd-voorburgwal-02/a",
              "widthWeight": 1
            },
            {
              "id": "mol-mosterd-voorburgwal-02/b",
              "widthWeight": 1
            }
          ],
          "paintedPixel": [4210, 1958]
        },
        {
          "id": "mol-mosterd-voorburgwal-03",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "plots": [
            {
              "id": "mol-mosterd-voorburgwal-03/a",
              "widthWeight": 1
            },
            {
              "id": "mol-mosterd-voorburgwal-03/b",
              "widthWeight": 1
            }
          ],
          "paintedPixel": [4241, 1979]
        },
        {
          "id": "mol-mosterd-voorburgwal-04",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "plots": [
            {
              "id": "mol-mosterd-voorburgwal-04/a",
              "widthWeight": 1
            },
            {
              "id": "mol-mosterd-voorburgwal-04/b",
              "widthWeight": 1
            }
          ],
          "paintedPixel": [4267, 2003]
        },
        {
          "id": "mol-mosterd-voorburgwal-05",
          "widthWeight": 0.95,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "plots": [
            {
              "id": "mol-mosterd-voorburgwal-05/a",
              "widthWeight": 1
            },
            {
              "id": "mol-mosterd-voorburgwal-05/b",
              "widthWeight": 1
            }
          ],
          "paintedPixel": [4294, 2026]
        },
        {
          "id": "mol-mosterd-voorburgwal-06",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "tile",
          "gable": "plain",
          "plots": [
            {
              "id": "mol-mosterd-voorburgwal-06/a",
              "widthWeight": 1
            },
            {
              "id": "mol-mosterd-voorburgwal-06/b",
              "widthWeight": 1
            }
          ],
          "paintedPixel": [4315, 2053]
        },
        {
          "id": "mol-mosterd-voorburgwal-07",
          "widthWeight": 0.95,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "plots": [
            {
              "id": "mol-mosterd-voorburgwal-07/a",
              "widthWeight": 1
            },
            {
              "id": "mol-mosterd-voorburgwal-07/b",
              "widthWeight": 1
            }
          ],
          "paintedPixel": [4357, 2073]
        },
        {
          "id": "mol-mosterd-voorburgwal-08",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "plots": [
            {
              "id": "mol-mosterd-voorburgwal-08/a",
              "widthWeight": 1
            },
            {
              "id": "mol-mosterd-voorburgwal-08/b",
              "widthWeight": 1
            }
          ],
          "paintedPixel": [4370, 2100]
        }
      ]
    },
    {
      "id": "mol-mosterd-achterburgwal",
      "source": "quay-nieuwezijds-achterburgwal",
      "side": "left",
      "from": 430,
      "to": 353,
      "depth": 15,
      "shear": -0.04,
      "opposite": "quay-nieuwezijds-voorburgwal-4",
      "evidence": "inferred",
      "houses": [
        {
          "id": "mol-mosterd-achterburgwal-01/a",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "mol-mosterd-achterburgwal-01/b",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "mol-mosterd-achterburgwal-02/a",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "mol-mosterd-achterburgwal-02/b",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "mol-mosterd-achterburgwal-03/a",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "mol-mosterd-achterburgwal-03/b",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "mol-mosterd-achterburgwal-04/a",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "mol-mosterd-achterburgwal-04/b",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "mol-mosterd-achterburgwal-05/a",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "mol-mosterd-achterburgwal-05/b",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "mol-mosterd-achterburgwal-06/a",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "mol-mosterd-achterburgwal-06/b",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "mol-mosterd-achterburgwal-07/a",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "mol-mosterd-achterburgwal-07/b",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        }
      ],
      "frontOffset": 0.25,
      "plotAxis": [0.858, -0.514]
    }
  ]
}
